export const accountTypes = ['user', 'ambassador', 'admin', 'owner'] as const;

export type AccountType = typeof accountTypes[number];

export type AccountEntitlements = {
    adminDashboard: boolean;
    accountManagement: 'none' | 'limited' | 'full';
    tripBilling: 'standard' | 'free';
    aiCredits: 'metered' | 'unlimited';
};

export const accountTypeEntitlements: Record<AccountType, AccountEntitlements> = {
    user: { adminDashboard: false, accountManagement: 'none', tripBilling: 'standard', aiCredits: 'metered' },
    ambassador: { adminDashboard: false, accountManagement: 'none', tripBilling: 'free', aiCredits: 'unlimited' },
    admin: { adminDashboard: true, accountManagement: 'limited', tripBilling: 'standard', aiCredits: 'unlimited' },
    owner: { adminDashboard: true, accountManagement: 'full', tripBilling: 'free', aiCredits: 'unlimited' },
};

export function normalizeAccountType(value?: string | null): AccountType { return accountTypes.includes(value as AccountType) ? value as AccountType : 'user'; }
export function hasAdminAccess(value?: string | null) { return accountTypeEntitlements[normalizeAccountType(value)].adminDashboard; }
